module.exports = __webpack_public_path__ + "img/icon_statistic_off.6bd6752d.svg";